import axios from 'axios';
import config from '../Config'; // Path to your config file
import authHeader from './auth-header'; // Path to your auth header


const API_URL = config.API_URL; // Base API URL
const API_VERSION = config.API_VERSION; // API version
const addPurchaser = (formData) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/purchaser/`,
    formData, // Payload for the request body
    { headers: authHeader() } // Authentication header
  );
};
const getPurchaserList = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/first_weight_entry/purchasers/`, {
    headers: authHeader(),
    params: {
      deleted: 0,
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    } // Parameters for pagination and search
  });
};

const getPurchaserDropdown = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/purchaser/`, {
    headers: authHeader(),
    params: {
      fields: 'id, name, deleted',
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    } // Parameters for pagination and search
  });
};

const getPurchaserArchiveList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/purchaser-archive', {
    headers: authHeader(), params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    }
  });
};
const updatePurchaser = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/purchaser/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    { headers: authHeader() } // Authentication header
  );
};
const deletePurchaser = (id) => {
   
  return axios.delete(
      `${API_URL}/api/${API_VERSION}/purchaser/${id}/`,
      { headers: authHeader() }, // Authentication header
    );
};
const unArchivePurchaser = (id) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/purchaser/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() } // Authentication header
  );
};
const purchaserService = {
  addPurchaser,
  getPurchaserList,
  getPurchaserArchiveList,
  updatePurchaser,
  deletePurchaser,
  unArchivePurchaser,
  getPurchaserDropdown
};

export default purchaserService;
